// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const mcpTokenInNameMax = 60;

export const mcpTokenInScopesOneItemMax = 64;

export const mcpTokenInScopesOneMax = 20;

export const McpTokenIn = zod.object({
  "expires_on": zod.iso.date(),
  "name": zod.string().min(1).max(mcpTokenInNameMax),
  "scopes": zod.union([zod.array(zod.string().max(mcpTokenInScopesOneItemMax)).min(1).max(mcpTokenInScopesOneMax),zod.null()]).optional()
});

export type McpTokenIn = zod.input<typeof McpTokenIn>;
export type McpTokenInOutput = zod.output<typeof McpTokenIn>;
